angular.module("vgresiduos").controller("CreateSupplierMonitoringCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedores/monitoramento`, [
				{ key: "supplierId", value: $stateParams.supplierId }
			]);
		};
	}
]);
